import React, { useState, useEffect } from "react";
import MasterTable from "../common/MasterTable";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import CustomAlert from "../../helpers/CustomAlert";
import Loader from "../Loader/Loader";
import { format, parse } from "date-fns";
import CustReportFilterModal from "./CustReportFilterModal";
import FullStatement from "./FullStatement";
import DownloadReport from "./DownloadReport";
import IPWhitelistingModal from "../ipwhitelisting/IPWhitelistingModal";
import confetti from "canvas-confetti";
import { useSelector, useDispatch } from "react-redux";
import { setBalance } from "../store/balance/balanceSlice";
import { formatDateToYYYYMMDD } from "../../helpers/DateHelpers";
import BillerOperatorPopupViewer from "./BillerOperatorPopupViewer";
import RechargeModal from "./RechargeModal";

const defaultFilterData = {
  companyCode: "",
  fromDate: "",
  toDate: "",
  fromAmount: "",
  toAmount: "",
  billerCategory: "",
  billerName: "",
  billerStatus: [],
};

const TransactionReport = () => {
  const pageSize = 10;
  const loggedInUserName = sessionStorage.getItem("username");
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const [noData, setNoData] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingFullSt, setLoadingFullSt] = useState(false);
  const [loadingDowRep, setLoadingDowRep] = useState(false);
  const [rechargeData, setRechargeData] = useState([]);
  const [pageDetails, setPageDetails] = useState(null);
  const [pageDowRepDetails, setPageDowRepDetails] = useState(null);
  const [noDowRepData, setNoDowRepData] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowData, setRowData] = useState(null);
  const [activeTab, setActiveTab] = useState("Recharge");
  const [isModalOpenFilter, setIsModalOpenFilter] = useState(false);
  const [filterData, setFilterData] = useState(defaultFilterData);
  const [isModalOpenReport, setIsModalOpenReport] = useState(false);
  const [isModalOpenReportDown, setIsModalOpenReportDown] = useState(false);
  const [isModalOpenIpWhiteL, setIsModalOpenIpWhiteL] = useState(false);
  const [downloadReportData, setDownloadReportData] = useState([]);
  const [isOpenRechargeModal, setIsOpenRechargeModal] = useState(false);

  const openModalReport = () => {
    setIsModalOpenReport(true);
  };

  const closeModalReport = () => {
    setIsModalOpenReport(false);
  };

  const openModalReportDown = () => {
    setIsModalOpenReportDown(true);
  };

  const closeModalReportDown = () => {
    setIsModalOpenReportDown(false);
  };

  const openModalIpWhiteL = () => {
    setIsModalOpenIpWhiteL(true);
  };

  const closeModalIpWhiteL = () => {
    setIsModalOpenIpWhiteL(false);
  };

  const openModalFilter = () => {
    setIsModalOpenFilter(true);
  };

  const closeModalFilter = () => {
    setIsModalOpenFilter(false);
  };

  const fetchDashboardData = () => {
    const endDate = formatDateToYYYYMMDD(new Date());
    const startDate1 = new Date(new Date().setDate(new Date().getDate() - 90));
    const finalStartDate = formatDateToYYYYMMDD(startDate1);

    const requestBody = {
      startDate: finalStartDate,
      endDate: endDate,
      username: loggedInUserName,
    };

    axiosPostApi(apiList.DASHBOARD_DATA, requestBody)
      .then((response) => {
        if (response?.status === 200 && response?.data?.respCode === "00") {
          dispatch(setBalance(response?.data?.data));
        } else {
          console.warn("Dashboard data fetch failed:", response?.data?.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching dashboard data:", error);
      });
  };

  useEffect(() => {
    fetchTransactionReportData(1, filterData);
  }, []);

  const fetchTransactionReportData = async (currentPage, filterData) => {
    try {
      const requestBody = {
        username: loggedInUserName,
        ...filterData,
        billerCategory: filterData?.billerCategory?.label || "",
      };

      const response = await axiosPostApi(
        `${apiList.FETCH_RECHARGE_DATA}?&pageSize=${pageSize}&pageNo=${currentPage}`,
        requestBody
      );

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setPageDetails(response?.data?.pageDetails);

        const modifiedData = modifyStructure(response?.data?.data);

        setRechargeData(modifiedData);
        if (modifiedData?.length === 0) {
          setNoData(true);
        } else {
          setNoData(false);
        }
        fetchDashboardData();
      } else {
        setNoData(true);
        setRechargeData([]);

        if (response?.data?.data !== null) {
          CustomAlert({
            title: "No Data",
            text: "No data available for the specified criteria.",
            icon: "info",
            confirmButtonText: "Okay",
          });
        }
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      }).then((result) => {
        if (result.isConfirmed) {
          sessionStorage.clear();
          window.location.href = "/";
        }
      });
    } finally {
      setLoading(false);
    }
  };

  const modifyStructure = (response) => {
    const modified = response?.map((user, index) => {
      const transDateParsed = user?.transDate
        ? parse(user.transDate, "dd-MM-yyyy HH:mm:ss", new Date())
        : null;

      const formattedPaymentAmount =
        user?.paymentAmount !== undefined
          ? Number(user.paymentAmount).toFixed(2)
          : "";

      const formattedWalletBalance =
        user?.walletBalance !== undefined
          ? Number(user?.walletBalance).toFixed(2)
          : "";

      const formattedRrn = user?.rrn ? (
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "visible",
            textOverflow: "clip",
          }}
        >
          {user?.rrn}
        </td>
      ) : (
        ""
      );

      return {
        ...user,
        id: index + 1,

        transDate: transDateParsed
          ? [
              format(transDateParsed, "dd-MM-yyyy"),
              <br key={index} />,
              format(transDateParsed, "HH:mm:ss"),
            ]
          : "",

        paymentAmount: formattedPaymentAmount,

        walletBalance: formattedWalletBalance,

        rrn: formattedRrn ? formattedRrn : "",

        billerName: (
          <BillerOperatorPopupViewer
            operatorCode={user?.operatorCode}
            operatorName={user?.operatorName}
            type="biller"
          />
        ),

        billerCategory: (
          <BillerOperatorPopupViewer
            operatorCode={user?.billerCategory}
            serviceName={user?.serviceName}
            type="service"
          />
        ),
      };
    });

    return modified;
  };

  const userHeaders = [
    "Sendor Id",
    "Entity Id",
    "Template Id",
    "Req Date",
    "Resp Date",
    "File Name",
    "Upload Status",
    "Download",
  ];

  const userHeaderToKeyMap = {
    "Sendor Id": "sendorId",
    "Entity Id": "entityId",
    "Template Id": "templateId",
    "Req Date": "uploadedDate",
    "Resp Date": "updatedDate",
    "File Name": "fileName",
    "Upload Status": "status",
    Download: "download",
  };

  const reportHeader = [
    "Status",
    "Description",
    "Company Code",
    "Company Name",
    "Date",
    "Mobile No",
    "Txn ID",
    "Amount (₹)",
    "Comm (₹)",
    "Total Amount (₹)",
    "Wallet Balance (₹)",
    "Biller Name",
    "Services",
    "Channel",
  ];

  const reportHeaderToKeyMap = {
    Status: "billerStatus",
    Description: "respDesc",
    "Company Code": "companyId",
    "Company Name": "companyName",
    Date: "transDate",
    "Mobile No": "custMobileNo",
    "Txn ID": "rrn",
    "Amount (₹)": "paymentAmount",
    "Comm (₹)": "sendorId",
    "Total Amount (₹)": "paymentAmount",
    "Wallet Balance (₹)": "walletBalance",
    "Biller Name": "billerName",
    Services: "billerCategory",
    Channel: "channel",
  };

  const handleReset = () => {
    setFilterData(defaultFilterData);
  };

  const handleFullStatement = async (fromDate, toDate) => {
    try {
      setLoadingFullSt(true);
      const payload = {
        username: user?.data?.username,
        fromDate,
        toDate,
      };

      const response = await axiosPostApi(
        `${apiList.TXN_REPORT_REQUEST_DOWNLOAD_HISTORY}`,
        payload
      );

      if (response.status === 200 && response.data.status === true) {
        CustomAlert({
          title: "Success",
          text: response?.data?.message || "Success",
          icon: "success",
          confirmButtonText: "Ok",
        });
        closeModalReport();

        const canvas = document.createElement("canvas");
        canvas.style.position = "fixed";
        canvas.style.top = "0";
        canvas.style.left = "0";
        canvas.style.width = "100%";
        canvas.style.height = "100%";
        canvas.style.zIndex = "3000";
        document.body.appendChild(canvas);

        const confettiInstance = confetti.create(canvas, {
          resize: true,
          useWorker: true,
        });

        confettiInstance({
          particleCount: 250,
          spread: 100,
          origin: { y: 0.6 },
        });

        setTimeout(() => {
          document.body.removeChild(canvas);
        }, 3000);
      } else {
        setNoData(true);
        setRechargeData([]);

        if (response?.data?.data !== null) {
          CustomAlert({
            title: "Failed",
            text: response?.data?.message || "Failed",
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      }
      setLoadingFullSt(false);
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while processing.",
        icon: "error",
        confirmButtonText: "Retry",
      }).then((result) => {
        if (result.isConfirmed) {
          sessionStorage.clear();
          window.location.href = "/";
        }
      });
    } finally {
      setLoadingFullSt(false);
    }
  };

  const handleDownloadReport = async (currentPage) => {
    setLoadingDowRep(true);
    setNoDowRepData(false);

    try {
      const requestBody = {
        username: user?.data?.username,
      };

      const response = await axiosPostApi(
        `${apiList.TXN_REPORT_DOWNLOAD_HISTORY}?&pageSize=${pageSize}&pageNo=${currentPage}`,
        requestBody
      );

      if (response && response.data) {
        if (response.data.status === true && response.data.respCode === "00") {
          const downloadHistory = response.data.data;
          setPageDowRepDetails(response.data.pageDetails);
          setDownloadReportData(downloadHistory || []);

          if (!downloadHistory || downloadHistory.length === 0) {
            setNoDowRepData(true);
          } else {
            setNoDowRepData(false);
          }
        } else {
          setDownloadReportData([]);
          setNoDowRepData(true);

          CustomAlert({
            title: "Failed",
            text: response.data.message || "Failed to fetch data",
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      } else {
        setDownloadReportData([]);
        setNoDowRepData(true);
      }
    } catch (error) {
      console.error("Error fetching download history:", error);
      setDownloadReportData([]);
      setNoDowRepData(true);

      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoadingDowRep(false);
    }
  };

  const handlerRecharge = (rowData, action) => {
    if (action === "recharge") {
      setRowData(rowData);
      setIsOpenRechargeModal(true);
    }
  };

  const pageSizeCount = pageDetails === null ? 0 : pageDetails.pageSize;
  const totalRecord = pageDetails === null ? 0 : pageDetails.totalRecords;

  return (
    <div style={{ padding: "16px", backgroundColor: "#eaedefc4" }}>
      <div
        style={{
          display: "flex",
          marginBottom: "16px",
          borderBottom: "1px solid #dee2e6",
        }}
      >
        <button
          onClick={() => setActiveTab("Recharge")}
          style={{
            padding: "8px 16px",
            borderTopRightRadius: "6px",
            borderTopLeftRadius: "6px",
            backgroundColor: activeTab === "Recharge" ? "#00b6ce" : "#e5e7eb",
            color: activeTab === "Recharge" ? "#fff" : "#000",
            border: "none",
            cursor: "pointer",
            fontWeight: "600",
          }}
        >
          Recharge
        </button>
        <button
          onClick={() => setActiveTab("Bbps")}
          style={{
            padding: "8px 16px",
            borderTopRightRadius: "6px",
            borderTopLeftRadius: "6px",
            backgroundColor: activeTab === "Bbps" ? "#00b6ce" : "#fff",
            color: activeTab === "Bbps" ? "#fff" : "#000",
            border: "none",
            cursor: "pointer",
            fontWeight: "600",
          }}
        >
          Bbps
        </button>
      </div>

      {activeTab === "Recharge" && (
        <div>
          {loading ? (
            <Loader />
          ) : (
            <div>
              <MasterTable
                loading={loading}
                pageDetails={pageDetails}
                headers={reportHeader}
                data={rechargeData}
                filterFields={["companyId"]}
                entityType="Report"
                headerToKeyMap={reportHeaderToKeyMap}
                noData={noData}
                currentPage={currentPage}
                pageSize={pageSizeCount}
                totalRecord={totalRecord}
                fetchNextData={(page) =>
                  fetchTransactionReportData(page, filterData)
                }
                setCurrentPage={setCurrentPage}
                setRowData={setRowData}
                openModalFilter={openModalFilter}
                handleReset={handleReset}
                filterData={filterData}
                fetchData={() => fetchTransactionReportData(1)}
                openModalSms={openModalReport}
                openModalSmsDown={openModalReportDown}
                openModalIpWhit={openModalIpWhiteL}
                handleAction={handlerRecharge}
              />
            </div>
          )}
          {isModalOpenFilter ? (
            <CustReportFilterModal
              show={isModalOpenFilter}
              handleClose={closeModalFilter}
              setRechargeData={setRechargeData}
              setPageDetails={setPageDetails}
              setNoData={setNoData}
              currentPage={currentPage}
              pageSize={pageSize}
              filterData={filterData}
              setFilterData={setFilterData}
              handleReset={handleReset}
            />
          ) : null}

          {isModalOpenReport ? (
            <FullStatement
              handleopenReport={isModalOpenReport}
              handleCloseReport={closeModalReport}
              callApi={handleFullStatement}
              loading={loadingFullSt}
            />
          ) : null}
          {isModalOpenReportDown ? (
            <DownloadReport
              handleopenReportDown={isModalOpenReportDown}
              handleCloseReportDown={closeModalReportDown}
              callApi={handleDownloadReport}
              data={downloadReportData}
              pageDowRepDetails={pageDowRepDetails}
              noData={noDowRepData}
              loading={loadingDowRep}
            />
          ) : null}
          {isModalOpenIpWhiteL ? (
            <IPWhitelistingModal
              show={isModalOpenIpWhiteL}
              handleClose={closeModalIpWhiteL}
            />
          ) : null}
        </div>
      )}
      {activeTab === "Bbps" && (
        <div>
          {loading ? (
            <Loader />
          ) : (
            <div>
              <MasterTable
                loading={loading}
                pageDetails={pageDetails}
                headers={userHeaders}
                data={rechargeData}
                entityType="Report"
                headerToKeyMap={userHeaderToKeyMap}
                noData={true}
                currentPage={currentPage}
                pageSize={pageSizeCount}
                totalRecord={totalRecord}
                fetchNextData={fetchTransactionReportData}
                setCurrentPage={setCurrentPage}
                setRowData={setRowData}
              />
            </div>
          )}
        </div>
      )}

      <RechargeModal
        show={isOpenRechargeModal}
        handleClose={() => setIsOpenRechargeModal(false)}
        callApi={() => fetchTransactionReportData(1)}
      />
    </div>
  );
};

export default TransactionReport;
